// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"PolicyDescription_smallPrint__hs5L6","link":"PolicyDescription_link__oKn1x","highlight":"PolicyDescription_highlight__lnUye"};